export const TOOLTIP_OPEN_DELAY = 500;
export const TOOLTIP_CLOSE_DELAY = 200;
import { useState, useRef, useEffect } from 'react';
export const useDelayedTooltip = ({ isOpen, setIsOpen, referenceElement, popperElement, arrowElement, isInteractive, openDelay = TOOLTIP_OPEN_DELAY, closeDelay = TOOLTIP_CLOSE_DELAY, }) => {
    const [triggerDelayOpen, setTriggerDelayOpen] = useState(false);
    const [triggerDelayClose, setTriggerDelayClose] = useState(false);
    const openTimer = useRef();
    const closeTimer = useRef();
    // Since we need to use setTimeout, which is considered a side effect,
    // we need to use useEffect. useEffect is a hook and so it cannot
    // be called from within another function. For example, we can't call
    // useEffect from inside onMouseOver. Instead, we introduce
    // a new state value, triggerDelayOpen, and use this as a flag within
    // useEffect.
    useEffect(() => {
        if (triggerDelayOpen && !openTimer.current) {
            openTimer.current = setTimeout(() => {
                setTriggerDelayOpen(false);
                if (!isOpen && referenceElement?.matches(':hover')) {
                    setIsOpen(true);
                }
                openTimer.current = undefined;
            }, openDelay);
        }
    }, [triggerDelayOpen, setIsOpen, isOpen, referenceElement, openDelay]);
    // Since we need to use setTimeout, which is considered a side effect,
    // we need to use useEffect. useEffect is a hook and so it cannot
    // be called from within another function. For example, we can't call
    // useEffect from inside onMouseLeave. Instead, we introduce
    // a new state value, triggerDelayClose, and use this as a flag within
    // useEffect.
    useEffect(() => {
        if (triggerDelayClose && !closeTimer?.current) {
            closeTimer.current = setTimeout(() => {
                setTriggerDelayClose(false);
                if (isOpen &&
                    !referenceElement?.matches(':hover') &&
                    (isInteractive ? !popperElement?.matches(':hover') && !arrowElement?.matches(':hover') : true)) {
                    setIsOpen(false);
                }
                closeTimer.current = undefined;
            }, closeDelay);
        }
    }, [triggerDelayClose, setIsOpen, isOpen, referenceElement, isInteractive, popperElement, arrowElement, closeDelay]);
    return {
        startDelayedOpen: () => setTriggerDelayOpen(true),
        startDelayedClose: () => setTriggerDelayClose(true),
    };
};
